import { CommonModule, PlatformLocation } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, DOCUMENT, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fromEvent, Subscription } from 'rxjs';
import { AppGlobalsModule } from 'src/app/app-globals.module';
import { UrlAddressService } from 'src/app/core/services/url-address/url-address.service';
import { UtilService } from 'src/app/core/services/util/util.service';
import { BrowserPlatformService } from 'src/app/core/services/browser-platform/browser-platform.service';

@Component({
    selector: 'light-box',
    templateUrl: './light-box.component.html',
    styleUrls: ['./light-box.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class LightBoxComponent implements OnDestroy {
    private _doc = inject<Document>(DOCUMENT);
    util = inject(UtilService);
    private _router = inject(Router);
    private _route = inject(ActivatedRoute);
    private _location = inject(PlatformLocation);
    private _urlAddress = inject(UrlAddressService);
    private _browser = inject(BrowserPlatformService);

    readonly FRAGMENT_MODAL = 'open-modal';
    private _isFragmentActive: boolean = false;
    private _isLightBoxOpen: boolean = false;
    public globals = AppGlobalsModule;
    @Input() isBlockScroll: boolean = false;
    @Input() set isLightBoxOpen(isLightBoxOpen: boolean) {
        // We need to initiate only ifthe box already open
        if (isLightBoxOpen) {
            this._onKeyupEvent();
        } else {
            this._offKeyupEvent();
        }
        this._isLightBoxOpen = isLightBoxOpen;
        // this.toggleNavigateFragment();
        this.isBlockScroll && this._toggleBodyScroll();
    }
    get isLightBoxOpen(): boolean {
        return this._isLightBoxOpen;
    }
    @Input() isCloseIcon: boolean = true;
    @Input() isCloseIcomInside!: boolean;
    /** set false when the content is a form - there enter means submit, not close */
    @Input() closeOnEnter: boolean = true;
    @Output() closeLightBox = new EventEmitter<Event>();
    private _keyupSubscription: Subscription | undefined;
    // private _fragmentSubscription: Subscription;
    // private _fragmentInsideSubscription: Subscription;

    // ngOnInit() {
    // this._fragmentSubscription = this._route.fragment.subscribe((fragment: string) => {
    //     this._isFragmentActive = fragment === this.FRAGMENT_MODAL
    // })
    // }

    ngOnDestroy() {
        this._offKeyupEvent();
        if (this.closeLightBox) this.closeLightBox.unsubscribe();
    }

    // private toggleKeyupEvent() {
    //     this.isLightBoxOpen ? this.onKeyupEvent() : this.offKeyupEvent()
    // }

    private _offKeyupEvent() {
        this.util.unsubscribe(this._keyupSubscription);
    }

    private _onKeyupEvent() {
        this._keyupSubscription = fromEvent<KeyboardEvent>(this._doc, 'keyup').subscribe((event: KeyboardEvent) => {
            if (event.key === 'Escape' || (this.closeOnEnter && event.key === 'Enter')) {
                this.closeLightBox.emit();
            }
        });
    }

    private _toggleBodyScroll() {
        if (!this._browser.isBrowser) return;
        if (this._isLightBoxOpen) {
            this._doc.body.style.top = `-${this._browser.scrollY}px`;
            this._doc.body.style.position = 'fixed';
            this._doc.body.style.width = '100%';
            this._doc.body.style.left = '0';
            this._doc.body.style.right = '0';
        } else {
            let scrollY = this._doc.body.style.top;
            this._doc.body.style.position = '';
            this._doc.body.style.top = '';
            this._doc.body.style.width = '';
            this._doc.body.style.left = '';
            this._doc.body.style.right = '';
            this._browser.nativeWindow?.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    }

    private toggleNavigateFragment() {
        // if (this._isLightBoxOpen) {
        //     if (this._urlAddress.getIsAngularApp()) {
        //         this._router.navigate([], { fragment: this.FRAGMENT_MODAL })
        //     } else if (window && window.location) {
        //         window.location.hash = this.FRAGMENT_MODAL;
        //     }
        //     AppGlobalsModule.setTimeoutIsNotServer(() => {
        //         this._fragmentInsideSubscription = this._route.fragment.subscribe(_ => {
        //             if (!this._isFragmentActive) {
        //                 this.closeLightBox.emit()
        //                 this._fragmentInsideSubscription.unsubscribe()
        //             }
        //         })
        //     }, 1000)
        // } else {
        //     if (this._isFragmentActive) {
        //         if (this._urlAddress.getIsAngularApp()) {
        //             this._location.back()
        //         } else if (window && window.history) {
        //             window.history.back()
        //         }
        //     }
        //     this.util.unsubscribe([this._fragmentInsideSubscription])
        // }
    }
}
